<div class="text-theme-gray-900 flex h-9 w-full flex-row justify-end bg-white text-xs font-bold">
  @let skipState = pageNavigationService.navigationState('skip')();
  @let continueState = pageNavigationService.navigationState('continue')();
  @let backState = pageNavigationService.navigationState('back')();

  @if (skipState.isActive) {
    <button
      class="bg-theme-gray-500 mr-auto cursor-pointer px-4 uppercase"
      (click)="pageNavigationService.triggerNavigation('skip')">
      {{ skipState.displayName }}
    </button>
  }

  @if (backState.isActive) {
    <button
      class="cursor-pointer px-4 uppercase"
      (click)="pageNavigationService.triggerNavigation('back')"
      [disabled]="!backState.isActive">
      {{ backState.displayName }}
    </button>
  }
  <button
    [appTooltip]="!continueState.isActive ? (continueState.inactiveReason ?? '') : ''"
    position="left"
    class="next-button bg-primary cursor-pointer px-4 text-white uppercase"
    [disabled]="!continueState.isActive"
    (click)="pageNavigationService.triggerNavigation('continue')">
    {{ continueState.displayName }}
  </button>
</div>
